import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ruCities from "./locales/ru/cities.json";
import ruThreshold from "./locales/ru/threshold.json";
import ruCommon from "./locales/ru/common.json";
import ruNav from "./locales/ru/nav.json";
import ruPlan from "./locales/ru/plan.json";
import ruProfile from "./locales/ru/profile.json";
import ruNotifications from "./locales/ru/notifications.json";
import ruGoal from "./locales/ru/goal.json";
import ruWorkout from "./locales/ru/workout.json";
import ruSettings from "./locales/ru/settings.json";
import ruWellness from "./locales/ru/wellness.json";
import ruDashboard from "./locales/ru/dashboard.json";
import ruRecord from "./locales/ru/record.json";
import ruDrill from "./locales/ru/drill.json";
import enRecord from "./locales/en/record.json";
import enDrill from "./locales/en/drill.json";
import deRecord from "./locales/de/record.json";
import deDrill from "./locales/de/drill.json";
import ukRecord from "./locales/uk/record.json";
import ukDrill from "./locales/uk/drill.json";
import ruZones from "./locales/ru/zones.json";
import ruInjuries from "./locales/ru/injuries.json";
import ruPlanHistory from "./locales/ru/plan_history.json";
import ruRaceCompare from "./locales/ru/race_compare.json";
import ruCycleCompare from "./locales/ru/cycle_compare.json";
import ruPrByRoute from "./locales/ru/pr_by_route.json";
import ruPlanTemplates from "./locales/ru/plan_templates.json";
import ruTravelMode from "./locales/ru/travel_mode.json";
import ruStravaSegments from "./locales/ru/strava_segments.json";
import ruCarbTiming from "./locales/ru/carb_timing.json";
import ruResilience from "./locales/ru/resilience.json";
import ruOwSpots from "./locales/ru/ow_spots.json";
import ruRouteHeatmap from "./locales/ru/route_heatmap.json";
import ruFeed from "./locales/ru/feed.json";
import ruDiary from "./locales/ru/diary.json";
import ruAchievements from "./locales/ru/achievements.json";
import ruStreaks from "./locales/ru/streaks.json";
import ruRoadmap from "./locales/ru/roadmap.json";
import ruWhatsNew from "./locales/ru/whats_new.json";
import ruCalendarSync from "./locales/ru/calendar_sync.json";
import ruLab from "./locales/ru/lab.json";
import ruInbox from "./locales/ru/inbox.json";
import ruAnalytics from "./locales/ru/analytics.json";
import ruEvents from "./locales/ru/events.json";
import ruRaceWeek from "./locales/ru/race_week.json";
import ruAuth from "./locales/ru/auth.json";
import ruExercises from "./locales/ru/exercises.json";
import ruFounding from "./locales/ru/founding.json";
import ruOnboarding from "./locales/ru/onboarding.json";
import ruKnowledge from "./locales/ru/knowledge.json";
import ruShoes from "./locales/ru/shoes.json";
import ruPair from "./locales/ru/pair.json";
import ruQuickLog from "./locales/ru/quick_log.json";
import ruFriends from "./locales/ru/friends.json";
import ruEquipment from "./locales/ru/equipment.json";
import ruSportProfile from "./locales/ru/sport_profile.json";
import ruSupport from "./locales/ru/support.json";
import ruTeam from "./locales/ru/team.json";
import ruCookie from "./locales/ru/cookie.json";
import ruBilling from "./locales/ru/billing.json";
import ruLanding from "./locales/ru/landing.json";
import ruDevices from "./locales/ru/devices.json";
import ruPredictions from "./locales/ru/predictions.json";
import ruReflections from "./locales/ru/reflections.json";
import ruRecap from "./locales/ru/recap.json";
import ruDay from "./locales/ru/day.json";
import ruPrivacyDashboard from "./locales/ru/privacy_dashboard.json";
import ruSearch from "./locales/ru/search.json";
import ruReferral from "./locales/ru/referral.json";
import ruNutritionLog from "./locales/ru/nutrition_log.json";

import ukCities from "./locales/uk/cities.json";
import ukThreshold from "./locales/uk/threshold.json";
import ukCommon from "./locales/uk/common.json";
import ukNav from "./locales/uk/nav.json";
import ukPlan from "./locales/uk/plan.json";
import ukProfile from "./locales/uk/profile.json";
import ukNotifications from "./locales/uk/notifications.json";
import ukGoal from "./locales/uk/goal.json";
import ukWorkout from "./locales/uk/workout.json";
import ukSettings from "./locales/uk/settings.json";
import ukWellness from "./locales/uk/wellness.json";
import ukDashboard from "./locales/uk/dashboard.json";
import ukZones from "./locales/uk/zones.json";
import ukInjuries from "./locales/uk/injuries.json";
import ukPlanHistory from "./locales/uk/plan_history.json";
import ukRaceCompare from "./locales/uk/race_compare.json";
import ukCycleCompare from "./locales/uk/cycle_compare.json";
import ukPrByRoute from "./locales/uk/pr_by_route.json";
import ukPlanTemplates from "./locales/uk/plan_templates.json";
import ukTravelMode from "./locales/uk/travel_mode.json";
import ukStravaSegments from "./locales/uk/strava_segments.json";
import ukCarbTiming from "./locales/uk/carb_timing.json";
import ukResilience from "./locales/uk/resilience.json";
import ukOwSpots from "./locales/uk/ow_spots.json";
import ukRouteHeatmap from "./locales/uk/route_heatmap.json";
import ukFeed from "./locales/uk/feed.json";
import ukDiary from "./locales/uk/diary.json";
import ukAchievements from "./locales/uk/achievements.json";
import ukStreaks from "./locales/uk/streaks.json";
import ukRoadmap from "./locales/uk/roadmap.json";
import ukWhatsNew from "./locales/uk/whats_new.json";
import ukCalendarSync from "./locales/uk/calendar_sync.json";
import ukLab from "./locales/uk/lab.json";
import ukInbox from "./locales/uk/inbox.json";
import ukAnalytics from "./locales/uk/analytics.json";
import ukEvents from "./locales/uk/events.json";
import ukRaceWeek from "./locales/uk/race_week.json";
import ukAuth from "./locales/uk/auth.json";
import ukExercises from "./locales/uk/exercises.json";
import ukFounding from "./locales/uk/founding.json";
import ukOnboarding from "./locales/uk/onboarding.json";
import ukKnowledge from "./locales/uk/knowledge.json";
import ukShoes from "./locales/uk/shoes.json";
import ukPair from "./locales/uk/pair.json";
import ukQuickLog from "./locales/uk/quick_log.json";
import ukFriends from "./locales/uk/friends.json";
import ukEquipment from "./locales/uk/equipment.json";
import ukSportProfile from "./locales/uk/sport_profile.json";
import ukSupport from "./locales/uk/support.json";
import ukTeam from "./locales/uk/team.json";
import ukCookie from "./locales/uk/cookie.json";
import ukBilling from "./locales/uk/billing.json";
import ukLanding from "./locales/uk/landing.json";
import ukDevices from "./locales/uk/devices.json";
import ukPredictions from "./locales/uk/predictions.json";
import ukReflections from "./locales/uk/reflections.json";
import ukRecap from "./locales/uk/recap.json";
import ukDay from "./locales/uk/day.json";
import ukPrivacyDashboard from "./locales/uk/privacy_dashboard.json";
import ukSearch from "./locales/uk/search.json";
import ukReferral from "./locales/uk/referral.json";
import ukNutritionLog from "./locales/uk/nutrition_log.json";

import enCities from "./locales/en/cities.json";
import enThreshold from "./locales/en/threshold.json";
import enCommon from "./locales/en/common.json";
import enNav from "./locales/en/nav.json";
import enPlan from "./locales/en/plan.json";
import enProfile from "./locales/en/profile.json";
import enNotifications from "./locales/en/notifications.json";
import enGoal from "./locales/en/goal.json";
import enWorkout from "./locales/en/workout.json";
import enSettings from "./locales/en/settings.json";
import enWellness from "./locales/en/wellness.json";
import enDashboard from "./locales/en/dashboard.json";
import enZones from "./locales/en/zones.json";
import enInjuries from "./locales/en/injuries.json";
import enPlanHistory from "./locales/en/plan_history.json";
import enRaceCompare from "./locales/en/race_compare.json";
import enCycleCompare from "./locales/en/cycle_compare.json";
import enPrByRoute from "./locales/en/pr_by_route.json";
import enPlanTemplates from "./locales/en/plan_templates.json";
import enTravelMode from "./locales/en/travel_mode.json";
import enStravaSegments from "./locales/en/strava_segments.json";
import enCarbTiming from "./locales/en/carb_timing.json";
import enResilience from "./locales/en/resilience.json";
import enOwSpots from "./locales/en/ow_spots.json";
import enRouteHeatmap from "./locales/en/route_heatmap.json";
import enFeed from "./locales/en/feed.json";
import enDiary from "./locales/en/diary.json";
import enAchievements from "./locales/en/achievements.json";
import enStreaks from "./locales/en/streaks.json";
import enRoadmap from "./locales/en/roadmap.json";
import enWhatsNew from "./locales/en/whats_new.json";
import enCalendarSync from "./locales/en/calendar_sync.json";
import enLab from "./locales/en/lab.json";
import enInbox from "./locales/en/inbox.json";
import enAnalytics from "./locales/en/analytics.json";
import enEvents from "./locales/en/events.json";
import enRaceWeek from "./locales/en/race_week.json";
import enAuth from "./locales/en/auth.json";
import enExercises from "./locales/en/exercises.json";
import enFounding from "./locales/en/founding.json";
import enOnboarding from "./locales/en/onboarding.json";
import enKnowledge from "./locales/en/knowledge.json";
import enShoes from "./locales/en/shoes.json";
import enPair from "./locales/en/pair.json";
import enQuickLog from "./locales/en/quick_log.json";
import enFriends from "./locales/en/friends.json";
import enEquipment from "./locales/en/equipment.json";
import enSportProfile from "./locales/en/sport_profile.json";
import enSupport from "./locales/en/support.json";
import enTeam from "./locales/en/team.json";
import enCookie from "./locales/en/cookie.json";
import enBilling from "./locales/en/billing.json";
import enLanding from "./locales/en/landing.json";
import enDevices from "./locales/en/devices.json";
import enPredictions from "./locales/en/predictions.json";
import enReflections from "./locales/en/reflections.json";
import enRecap from "./locales/en/recap.json";
import enDay from "./locales/en/day.json";
import enPrivacyDashboard from "./locales/en/privacy_dashboard.json";
import enSearch from "./locales/en/search.json";
import enReferral from "./locales/en/referral.json";
import enNutritionLog from "./locales/en/nutrition_log.json";

import deCities from "./locales/de/cities.json";
import deThreshold from "./locales/de/threshold.json";
import deCommon from "./locales/de/common.json";
import deNav from "./locales/de/nav.json";
import dePlan from "./locales/de/plan.json";
import deProfile from "./locales/de/profile.json";
import deNotifications from "./locales/de/notifications.json";
import deGoal from "./locales/de/goal.json";
import deWorkout from "./locales/de/workout.json";
import deSettings from "./locales/de/settings.json";
import deWellness from "./locales/de/wellness.json";
import deDashboard from "./locales/de/dashboard.json";
import deZones from "./locales/de/zones.json";
import deInjuries from "./locales/de/injuries.json";
import dePlanHistory from "./locales/de/plan_history.json";
import deRaceCompare from "./locales/de/race_compare.json";
import deCycleCompare from "./locales/de/cycle_compare.json";
import dePrByRoute from "./locales/de/pr_by_route.json";
import dePlanTemplates from "./locales/de/plan_templates.json";
import deTravelMode from "./locales/de/travel_mode.json";
import deStravaSegments from "./locales/de/strava_segments.json";
import deCarbTiming from "./locales/de/carb_timing.json";
import deResilience from "./locales/de/resilience.json";
import deOwSpots from "./locales/de/ow_spots.json";
import deRouteHeatmap from "./locales/de/route_heatmap.json";
import deFeed from "./locales/de/feed.json";
import deDiary from "./locales/de/diary.json";
import deAchievements from "./locales/de/achievements.json";
import deStreaks from "./locales/de/streaks.json";
import deRoadmap from "./locales/de/roadmap.json";
import deWhatsNew from "./locales/de/whats_new.json";
import deCalendarSync from "./locales/de/calendar_sync.json";
import deLab from "./locales/de/lab.json";
import deInbox from "./locales/de/inbox.json";
import deAnalytics from "./locales/de/analytics.json";
import deEvents from "./locales/de/events.json";
import deRaceWeek from "./locales/de/race_week.json";
import deAuth from "./locales/de/auth.json";
import deExercises from "./locales/de/exercises.json";
import deFounding from "./locales/de/founding.json";
import deOnboarding from "./locales/de/onboarding.json";
import deKnowledge from "./locales/de/knowledge.json";
import deShoes from "./locales/de/shoes.json";
import dePair from "./locales/de/pair.json";
import deQuickLog from "./locales/de/quick_log.json";
import deFriends from "./locales/de/friends.json";
import deEquipment from "./locales/de/equipment.json";
import deSportProfile from "./locales/de/sport_profile.json";
import deSupport from "./locales/de/support.json";
import deTeam from "./locales/de/team.json";
import deCookie from "./locales/de/cookie.json";
import deBilling from "./locales/de/billing.json";
import deLanding from "./locales/de/landing.json";
import deDevices from "./locales/de/devices.json";
import dePredictions from "./locales/de/predictions.json";
import deReflections from "./locales/de/reflections.json";
import deRecap from "./locales/de/recap.json";
import deDay from "./locales/de/day.json";
import dePrivacyDashboard from "./locales/de/privacy_dashboard.json";
import deSearch from "./locales/de/search.json";
import deReferral from "./locales/de/referral.json";
import deNutritionLog from "./locales/de/nutrition_log.json";

// it/pl removed from supported list — launch locales = ru/en/de/uk (sess 19).
// Stub locale files kept in repo, but i18next will fall back to "ru" for these
// browser preferences via fallbackLng.
const SUPPORTED = ["ru", "uk", "en", "de"] as const;
export type Locale = (typeof SUPPORTED)[number];

function detectTgLanguage(): string | undefined {
  try {
    // @ts-ignore — TG WebApp is injected externally
    const tg = window.Telegram?.WebApp;
    const lang = tg?.initDataUnsafe?.user?.language_code;
    if (lang && SUPPORTED.includes(lang as Locale)) return lang;
  } catch {
    // silent: Telegram WebApp API absent or read-only
  }
  return undefined;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { cities: ruCities, threshold: ruThreshold, common: ruCommon, nav: ruNav, plan: ruPlan, profile: ruProfile, notifications: ruNotifications, goal: ruGoal, workout: ruWorkout, settings: ruSettings, wellness: ruWellness, dashboard: ruDashboard, zones: ruZones, injuries: ruInjuries, plan_history: ruPlanHistory, race_compare: ruRaceCompare, cycle_compare: ruCycleCompare, pr_by_route: ruPrByRoute, plan_templates: ruPlanTemplates, travel_mode: ruTravelMode, strava_segments: ruStravaSegments, carb_timing: ruCarbTiming, resilience: ruResilience, ow_spots: ruOwSpots, route_heatmap: ruRouteHeatmap, feed: ruFeed, diary: ruDiary, achievements: ruAchievements, streaks: ruStreaks, roadmap: ruRoadmap, whats_new: ruWhatsNew, calendar_sync: ruCalendarSync, lab: ruLab, inbox: ruInbox, analytics: ruAnalytics, events: ruEvents, race_week: ruRaceWeek, auth: ruAuth, exercises: ruExercises, founding: ruFounding, onboarding: ruOnboarding, knowledge: ruKnowledge, shoes: ruShoes, support: ruSupport, team: ruTeam, cookie: ruCookie, billing: ruBilling, landing: ruLanding, pair: ruPair, quick_log: ruQuickLog, friends: ruFriends, equipment: ruEquipment, sport_profile: ruSportProfile, devices: ruDevices, predictions: ruPredictions, reflections: ruReflections, recap: ruRecap, day: ruDay, privacy_dashboard: ruPrivacyDashboard, search: ruSearch, referral: ruReferral, nutrition_log: ruNutritionLog, record: ruRecord, drill: ruDrill },
      uk: { cities: ukCities, threshold: ukThreshold, common: ukCommon, nav: ukNav, plan: ukPlan, profile: ukProfile, notifications: ukNotifications, goal: ukGoal, workout: ukWorkout, settings: ukSettings, wellness: ukWellness, dashboard: ukDashboard, zones: ukZones, injuries: ukInjuries, plan_history: ukPlanHistory, race_compare: ukRaceCompare, cycle_compare: ukCycleCompare, pr_by_route: ukPrByRoute, plan_templates: ukPlanTemplates, travel_mode: ukTravelMode, strava_segments: ukStravaSegments, carb_timing: ukCarbTiming, resilience: ukResilience, ow_spots: ukOwSpots, route_heatmap: ukRouteHeatmap, feed: ukFeed, diary: ukDiary, achievements: ukAchievements, streaks: ukStreaks, roadmap: ukRoadmap, whats_new: ukWhatsNew, calendar_sync: ukCalendarSync, lab: ukLab, inbox: ukInbox, analytics: ukAnalytics, events: ukEvents, race_week: ukRaceWeek, auth: ukAuth, exercises: ukExercises, founding: ukFounding, onboarding: ukOnboarding, knowledge: ukKnowledge, shoes: ukShoes, support: ukSupport, team: ukTeam, cookie: ukCookie, billing: ukBilling, landing: ukLanding, pair: ukPair, quick_log: ukQuickLog, friends: ukFriends, equipment: ukEquipment, sport_profile: ukSportProfile, devices: ukDevices, predictions: ukPredictions, reflections: ukReflections, recap: ukRecap, day: ukDay, privacy_dashboard: ukPrivacyDashboard, search: ukSearch, referral: ukReferral, nutrition_log: ukNutritionLog, record: ukRecord, drill: ukDrill },
      en: { cities: enCities, threshold: enThreshold, common: enCommon, nav: enNav, plan: enPlan, profile: enProfile, notifications: enNotifications, goal: enGoal, workout: enWorkout, settings: enSettings, wellness: enWellness, dashboard: enDashboard, zones: enZones, injuries: enInjuries, plan_history: enPlanHistory, race_compare: enRaceCompare, cycle_compare: enCycleCompare, pr_by_route: enPrByRoute, plan_templates: enPlanTemplates, travel_mode: enTravelMode, strava_segments: enStravaSegments, carb_timing: enCarbTiming, resilience: enResilience, ow_spots: enOwSpots, route_heatmap: enRouteHeatmap, feed: enFeed, diary: enDiary, achievements: enAchievements, streaks: enStreaks, roadmap: enRoadmap, whats_new: enWhatsNew, calendar_sync: enCalendarSync, lab: enLab, inbox: enInbox, analytics: enAnalytics, events: enEvents, race_week: enRaceWeek, auth: enAuth, exercises: enExercises, founding: enFounding, onboarding: enOnboarding, knowledge: enKnowledge, shoes: enShoes, support: enSupport, team: enTeam, cookie: enCookie, billing: enBilling, landing: enLanding, pair: enPair, quick_log: enQuickLog, friends: enFriends, equipment: enEquipment, sport_profile: enSportProfile, devices: enDevices, predictions: enPredictions, reflections: enReflections, recap: enRecap, day: enDay, privacy_dashboard: enPrivacyDashboard, search: enSearch, referral: enReferral, nutrition_log: enNutritionLog, record: enRecord, drill: enDrill },
      de: { cities: deCities, threshold: deThreshold, common: deCommon, nav: deNav, plan: dePlan, profile: deProfile, notifications: deNotifications, goal: deGoal, workout: deWorkout, settings: deSettings, wellness: deWellness, dashboard: deDashboard, zones: deZones, injuries: deInjuries, plan_history: dePlanHistory, race_compare: deRaceCompare, cycle_compare: deCycleCompare, pr_by_route: dePrByRoute, plan_templates: dePlanTemplates, travel_mode: deTravelMode, strava_segments: deStravaSegments, carb_timing: deCarbTiming, resilience: deResilience, ow_spots: deOwSpots, route_heatmap: deRouteHeatmap, feed: deFeed, diary: deDiary, achievements: deAchievements, streaks: deStreaks, roadmap: deRoadmap, whats_new: deWhatsNew, calendar_sync: deCalendarSync, lab: deLab, inbox: deInbox, analytics: deAnalytics, events: deEvents, race_week: deRaceWeek, auth: deAuth, exercises: deExercises, founding: deFounding, onboarding: deOnboarding, knowledge: deKnowledge, shoes: deShoes, support: deSupport, team: deTeam, cookie: deCookie, billing: deBilling, landing: deLanding, pair: dePair, quick_log: deQuickLog, friends: deFriends, equipment: deEquipment, sport_profile: deSportProfile, devices: deDevices, predictions: dePredictions, reflections: deReflections, recap: deRecap, day: deDay, privacy_dashboard: dePrivacyDashboard, search: deSearch, referral: deReferral, nutrition_log: deNutritionLog, record: deRecord, drill: deDrill },
    },
    // TG WebApp lang takes priority; otherwise LanguageDetector reads browser/localStorage
    lng: detectTgLanguage(),
    fallbackLng: "ru",
    supportedLngs: SUPPORTED,
    defaultNS: "common",
    ns: ["cities", "threshold", "common", "nav", "plan", "profile", "notifications", "goal", "workout", "settings", "wellness", "dashboard", "zones", "feed", "diary", "achievements", "inbox", "analytics", "events", "race_week", "auth", "exercises", "founding", "onboarding", "knowledge", "shoes", "support", "landing", "pair", "quick_log", "friends", "sport_profile", "streaks", "roadmap", "whats_new", "calendar_sync", "lab", "equipment", "devices", "predictions", "reflections", "recap", "day", "privacy_dashboard", "search", "referral", "nutrition_log", "record", "drill"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "locale",
    },
  });

// A11y/SEO — sync <html lang> with active locale (sess 19).
// Default in index.html is "ru" for SSR/first paint; this updates after init
// and on every language change.
function syncHtmlLang(lng: string) {
  try {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lng;
    }
  } catch {
    // silent: document.documentElement may be locked-down (iframe / sandbox)
  }
}

syncHtmlLang(i18n.language || "ru");
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
